import Cookies from 'js-cookie';
import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import {
  GET_CART_REQUESTING,
  GET_CART_SUCCESS,
  RESET_CART_ISFETCHING
} from 'redux/cart/constants';

import {
  listCarrierPickupLocations,
  addCarrierPickupLocation,
  removeCarrierPickupLocation
} from './api';
import {
  LIST_CARRIER_PICKUP_LOCATION_REQUEST,
  CARRIER_PICKUP_LOCATION_REQUESTING,
  LIST_CARRIER_PICKUP_LOCATION_SUCCESS,
  RESET_CARRIER_PICKUP_LOCATION_ISFETCHING,
  ADD_CARRIER_PICKUP_LOCATION_REQUEST,
  REMOVE_CARRIER_PICKUP_LOCATION_REQUEST
} from './constants';

export function* list() {
  try {
    yield call(removeAPIError);
    yield put({ type: CARRIER_PICKUP_LOCATION_REQUESTING });
    const response = yield call(listCarrierPickupLocations, cartId());
    yield put({
      type: LIST_CARRIER_PICKUP_LOCATION_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CARRIER_PICKUP_LOCATION_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* add(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: GET_CART_REQUESTING });
    const response = yield call(
      addCarrierPickupLocation,
      cartId(),
      action.address
    );
    yield put({ type: GET_CART_SUCCESS, payload: response.data });
    if (action.successFunction) {
      action.successFunction();
    }
  } catch (error) {
    yield put({ type: RESET_CART_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* remove(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: GET_CART_REQUESTING });
    const response = yield call(removeCarrierPickupLocation, cartId());
    yield put({ type: GET_CART_SUCCESS, payload: response.data });
    if (action.successFunction) {
      action.successFunction();
    }
  } catch (error) {
    yield put({ type: RESET_CART_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  yield takeLatest(LIST_CARRIER_PICKUP_LOCATION_REQUEST, list);
  yield takeLatest(ADD_CARRIER_PICKUP_LOCATION_REQUEST, add);
  yield takeLatest(REMOVE_CARRIER_PICKUP_LOCATION_REQUEST, remove);
}

export default function* carrierPickupLocationSagas() {
  yield all([watchList()]);
}
const cartId = () => Cookies.get('cartId');
